import cloudflareAssets from "@/assets/cloudflareAssets";
import type { IAccount } from "@/modules/account/common/types";
import { Amount } from "@/shared/components";
import { MoreIcon } from "@/shared/components/SvgIcons";
import { useAppSelector } from "@/shared/hooks";
import { Divider } from "@ab.uitools/ui-library/components/Divider";
import { Image } from "@ab.uitools/ui-library/components/Image";
import { Text } from "@ab.uitools/ui-library/components/Text";
import type { MouseEvent } from "react";

interface Props extends IAccount {
  handleShowBalances?: (i: number) => void;
  index: number;
  className: string;
  canToggleBalance?: boolean;
  hasMoreAction?: boolean,
  rounded?: boolean
}

export const AccountItem = (
  {
    balance,
    currency,
    description,
    number,
    index,
    name,
    className,
    handleShowBalances,
    canToggleBalance = false,
    hasMoreAction,
    rounded = false,
  }: Props) => {
  const showBalances = useAppSelector((state) => state.dashboard.showBalances);

  const onShowBalance = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    handleShowBalances?.(index);
  };

  return (
    <div className={`flexbox align-items--center ${className}`}>
      <div className={`card-account-image flexbox ${rounded ? "rounded" : ""}`}>
        <Image imagePath={cloudflareAssets.Account}/>
      </div>
      <div className="flexbox flex-direction--column pl-16 card-account-content-wrapper">
        {!!index && (
          <Divider
            color="light"
            type="primary"
            isHorizontal
          />
        )}
        <div className="flexbox full-width card-account-body-wrapper">
          <div className="flexbox flex-direction--column card-account-body">
            <div className="full-width flexbox justify-content--between">
              <Text size="medium" weight="semibold" className="pr-16 truncate card-account-name">
                {name || description}
              </Text>

              <div
                onClick={onShowBalance}
                className="flexbox justify-content--center align-items--end flex-direction--column pr-6 card-account-balance"
              >
                <Amount
                  currency={currency}
                  amount={balance}
                  isShow={!canToggleBalance || showBalances[index]}
                />
              </div>
            </div>
            <div className="flexbox align-items--center">
              <Text className="card-account-number">
                {number}
              </Text>
            </div>
          </div>
          {hasMoreAction && (
            <div className="cursor-pointer flexbox align-items--center">
              <MoreIcon type="secondary"/>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
